import Dexie from 'dexie';

export const db = new Dexie('cpl');
const PLOT_COLUMNS = ['&id', 'plan', 'block', 'property', 'lot', 'areaCode'];
db.version(1).stores({
	plots: PLOT_COLUMNS.join(', '),
});
